import { useVenderSupportItems } from './useVenderSupportItems'

export const useVenderServiceCapacity = (props) => {
  const result = useVenderSupportItems(
    props
      ? {
          target: 'serviceCapacity',
          serviceClassificationId: props.serviceClassificationId,
          county: props.county,
        }
      : null
  )
  if (result?.data) return { ...result, data: result.data }
  return result
}
